const output = {
  value: ["required", "trim", "string", "url"],
  name: ["required", "trim", "string"],
  description: ["trim", "string"],
  type: ["trim", "string"],
  visibility: ["trim", "string"],
};

export default output;
